import axios from 'axios'
import UserModel from '../models/user.model';
const USER_KEY = "authenticated_user";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL_AUTH,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Oc-Merchant-Id': process.env.VUE_APP_MERCHANT_ID,
  },
  timeout: 60000
})

export default {
  login(username, password) {
    return apiClient.post('/login', {
      email: username,
      password: password
    });
  },
  logout() {
    return apiClient.post('/logout');
  },
  forgotPassword(username) {
    return apiClient.post('/forgot', {
      email: username
    });
  },
  setLocal(user) {
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  getLocal() {
    var local_store = JSON.parse(window.localStorage.getItem(USER_KEY));
    var user_model = new UserModel(local_store);       
    return user_model;
  },
  deleteLocal() {
    window.localStorage.removeItem(USER_KEY);
  }
}